var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect } from "react";
import { createPortal } from "react-dom";
import { FloatingList } from "./floatingList";
var FloatingMenu = memo(function (props) {
    var open = props.open, disablePortal = props.disablePortal;
    var id = "floating-menu-element";
    var el = document.createElement("div");
    el.setAttribute("id", id);
    useEffect(function () {
        if (open && !disablePortal) {
            document.body.appendChild(el);
        }
        return function () {
            el.remove();
        };
    }, [open, el, disablePortal]);
    if (disablePortal) {
        return open ? _jsx(FloatingList, __assign({ id: id }, props)) : null;
    }
    return createPortal(_jsx(FloatingList, __assign({ id: id }, props)), el);
});
export { FloatingMenu };
export default FloatingMenu;
